import type { CustomRow } from '@jane/bloom/types/schemas/roots/bloom/customRow';
import type { ProductSearchFilterCategory } from '@jane/bloom/viewModels/productSearchFilters';

import { getEnabledCustomRows } from './getCustomSortedCategories';

// sort alphabetically
export function getDefaultSortedCategories({
  categories,
  customRows,
}: {
  categories: ProductSearchFilterCategory[];
  customRows: CustomRow[];
}) {
  const enabledCategories = getEnabledCustomRows(categories, customRows);

  return enabledCategories.sort((a, b) => {
    return a.label?.localeCompare(b.label);
  });
}
